import { NotificationsProvider } from '@mantine/notifications';
import { MantineProvider } from '@mantine/core';
import ReactDOM from 'react-dom';
// import React from 'react';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ErrorBoundary from './error-boundry';
import reportWebVitals from './reportWebVitals';
import { AppProviders } from './context';
import theme from './mantine.config';
import App from './App';
import './globals';

// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
ReactDOM.render(
  // <React.StrictMode>
  <MantineProvider
    emotionOptions={{ key: 'agri', prepend: false }}
    theme={theme}
    styles={{
      Tabs: (theme) => ({
        tabControl: {
          fontSize: theme.fontSizes.md,
          color: `${theme.colors.darkColors[2]} !important`
        },
        tabActive: {
          color: `${theme.colors.darkColors[0]} !important`,
          borderColor: `${theme.colors.secondaryColors[0]} !important`
        }
      })
    }}
  >
    <ErrorBoundary key={'App'}>
      <AppProviders>
        <NotificationsProvider position="top-center">
          <App />
        </NotificationsProvider>
      </AppProviders>
    </ErrorBoundary>
  </MantineProvider>,
  // </React.StrictMode>
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
